import { render, staticRenderFns } from "./SelectSupplierType.vue?vue&type=template&id=526337e0&"
import script from "./SelectSupplierType.vue?vue&type=script&lang=js&"
export * from "./SelectSupplierType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports